// CookieConsent.jsx
import { useEffect } from 'react';
import { isNativeApp } from '../../platform';

const SRC = 'https://app.termly.io/embed.min.js';
const WEBSITE_UUID = '3581675a-d686-4ccc-b9fe-594a7e6d9e4a';

export default function CookieConsent() {
	useEffect(() => {
		if (isNativeApp) return;
		if (document.querySelector(`script[src^="${SRC}"]`)) return;

		const s = document.createElement('script');
		s.src = SRC;
		s.defer = true;
		s.setAttribute('data-auto-block', 'on');
		s.setAttribute('data-website-uuid', WEBSITE_UUID);
		document.body.appendChild(s);

		return () => {
			try {
				s.remove();
			} catch (_) {}
		};
	}, []);

	return null;
}
